module.exports = __webpack_public_path__ + "static/media/cert4.88abd83a.png";